import { memo } from "react";
import { Tooltip } from "react-tooltip";

import { cnTwMerge } from "@vega-core/utils/cnTwMerge";
import { isFalsy } from "@vega-core/utils/isFalsy";
import { isTruthy } from "@vega-core/utils/isTruthy";

type Props = {
  ariaLabel?: string;
  bgColor?: string;
  borderRadius?: string;
  lightBackground?: boolean;
  positiveProgressBar?: boolean;
  progress: number;
  size: number;
  startPosition?: number;
  tooltip?: string;
};

export const ProgressBar = memo(
  ({
    ariaLabel,
    bgColor,
    borderRadius,
    lightBackground,
    positiveProgressBar,
    progress,
    size,
    startPosition,
    tooltip,
  }: Props) => (
    <div
      aria-label={ariaLabel}
      aria-valuemax={100}
      aria-valuemin={0}
      aria-valuenow={Math.round(progress)}
      className={cnTwMerge(
        "flex w-full items-center rounded-companyBorderRadius",
        {
          "bg-background/tertiary": isFalsy(lightBackground),
          "bg-border/primary": lightBackground,
          "mt-14": tooltip,
        },
        bgColor,
        borderRadius,
      )}
      data-testid="progress-bar-container"
      role="progressbar"
      style={{ height: `${size}px` }}
    >
      {isTruthy(tooltip) ? (
        <Tooltip
          className="vega-react-tooltip-positive"
          defaultIsOpen
          id="sell-progress-tooltip"
          isOpen
          opacity={1}
          place="top"
        />
      ) : null}
      <div
        className={cnTwMerge(
          "rounded-companyBorderRadius relative",
          {
            "bg-brand-default": isFalsy(positiveProgressBar),
            "bg-text/positive": positiveProgressBar,
          },
          borderRadius,
        )}
        data-testid="progress-bar-inner"
        style={{
          height: `${size - 2}px`,
          marginLeft: isTruthy(startPosition) ? `${startPosition}%` : "0",
          width: `${progress}%`,
        }}
      >
        {isTruthy(tooltip) ? (
          <div
            data-tooltip-content={tooltip}
            data-tooltip-id="sell-progress-tooltip"
          />
        ) : null}
      </div>
    </div>
  ),
);
